
import Vue from 'vue';
import { Button, Icon, RadioButton } from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';
import { LinkedinPostVisibility } from '@/helpers/linkedin';

interface Data {
  textToShare: string;
  defaultTextToShare: string;
  radioButtonSelected: LinkedinPostVisibility;
}

export default Vue.extend({
  components: {
    Button,
    RadioButton,
    Icon,
  },
  props: {
    course: {
      required: true,
      type: Object as Vue.PropType<CourseModel>,
    },
  },
  data(): Data {
    return {
      textToShare: '',
      defaultTextToShare: this.$tc(
        'postgradStudentDocuments.certificate.modal.shareOnLinkedin.defaultMessage',
      ),
      radioButtonSelected: LinkedinPostVisibility.PUBLIC,
    };
  },
  computed: {
    visibilityConfigurationOptions(): Array<object> {
      return [
        {
          key: LinkedinPostVisibility.PUBLIC,
          value: this.$tc(
            'postgradStudentDocuments.certificate.modal.shareOnLinkedin.shareOptions.public',
          ),
        },
        {
          key: LinkedinPostVisibility.CONNECTIONS,
          value: this.$tc(
            'postgradStudentDocuments.certificate.modal.shareOnLinkedin.shareOptions.private',
          ),
        },
      ];
    },
  },
  created() {
    this.textToShare = this.defaultTextToShare;
  },
  methods: {
    onRadioButtonClick(value: LinkedinPostVisibility): void {
      this.radioButtonSelected = value;
    },
    verifyIfTextWasChanged(): boolean {
      return this.textToShare !== this.defaultTextToShare;
    },
    shareCertificate(): void {
      this.$emit('onShare', {
        content: this.textToShare,
        visibility: this.radioButtonSelected,
        hasChangedContent: this.verifyIfTextWasChanged(),
      });
    },
  },
});
